import React from 'react';
import { Form, Segment, Grid } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';
import swal from 'sweetalert';

class FormAddBank extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         data:{
               "username":"",
               "nama":"",
               "kode":"",
               "alamat_bank":"",
               "nama_bank":"",
               "jabatan":"",
               "password":"",
               "alamat":"",
               "contact_bank":"",
               "contact":""
            },
         loading:false,
         error:false
      }

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
   }

   onSubmit(e){
      const {password, username, nama, alamat, jabatan, alamat_bank, nama_bank} = this.state.data;
      this.setState({loading:true});
      e.preventDefault();
      if((password===null || password==="") || (username===null || username==="")){
         this.setState({loading:false,error:true});
         swal("Username dan password harus diisi", {
            icon: "error",
         });
         return false;
      }else if(nama===null || nama===""){
         this.setState({loading: false, error: true});
         swal("", "Nama Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(jabatan===null || jabatan===""){
         this.setState({loading: false, error: true});
         swal("", "Jabatan Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(alamat===null || alamat===""){
         this.setState({loading: false, error: true});
         swal("", "Alamat Pegawai harus diisi terlebih dahulu", "error")
         return false;
      }else if(nama_bank===null || nama_bank===""){
         this.setState({loading: false, error: true});
         swal("", "Nama Bank harus diisi terlebih dahulu", "error")
         return false;
      }else if(alamat_bank===null || alamat_bank===""){
         this.setState({loading: false, error: true});
         swal("", "Alamat Bank harus diisi terlebih dahulu", "error")
         return false;
      }else{
         this.setState({loading:true});
         e.preventDefault();
         fetch(`${BaseURLDev}/users/bank`,{
            method: 'POST',
            headers,
            body: JSON.stringify(this.state.data)
         })
         .then(response => {
            if (!response.ok) { 
                  this.setState({loading:false,error:true});
                  swal("Register user bank gagal", {
                     icon: "error",
                  });
                  return Promise.reject(response.statusText);
               }
            else{
               swal("User bank telah ditambahkan", {
                  icon: "success",
               });
               this.setState({
                  loading:false,
                  error:false,
                  data:{
                     "username":"",
                     "nama":"",
                     "kode":"",
                     "alamat_bank":"",
                     "nama_bank":"",
                     "jabatan":"",
                     "password":"",
                     "alamat":"",
                     "contact_bank":"",
                     "contact":""
                  },
               });
            }
         })
      }
   }

   onCheckUserExists(username){
      fetch(`${BaseURLDev}/users/checkuser`, {
         headers,
         method: 'POST',
         body: JSON.stringify({
            "username": username
         })
      })
      .then(response => {
         if (!response.ok) { 
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         return resJSON.status;
      })
      .catch(e => {
         swal(`Check user error atau sedang terjadi gangguan di server`, {
            icon: "error",
         });
      })
   }

   onChange(e){
      this.setState({
         data:{...this.state.data, [e.target.name]:e.target.value}
      })
   }

   render() {

      const {username,password,nama,jabatan,kode,alamat,alamat_bank,contact,contact_bank,nama_bank} = this.state.data;
      const {error,loading} = this.state;

      return (
         <div>
            <Grid>         
               <Grid.Column width={8}>
                  <Segment color='violet'>
                     <Form onSubmit={this.onSubmit} error={error} loading={loading}>
                        <Form.Input autoFocus error={error} value={username} onChange={this.onChange} placeholder="Username" name="username" />
                        {/*error ? <Label  basic color='red' pointing>Username harus diisi!</Label>:null*/}
                        
                        <Form.Input error={error} type="password" value={password} onChange={this.onChange} placeholder="Password" name="password" />
                        {/*error ? <Label basic color='red' pointing>Password harus diisi!</Label>:null*/}
                        
                        <Form.Input value={kode} onChange={this.onChange} name="kode" placeholder="NIP/Kode Pegawai"/>
                        <Form.Input value={nama} onChange={this.onChange} name="nama" placeholder='Nama pegawai' />               
                        <Form.Input value={jabatan} onChange={this.onChange} name="jabatan" placeholder='Jabatan pegawai' />               
                        <Form.Input value={contact} onChange={this.onChange} name="contact" placeholder='Nomor contact' />               
                        <Form.TextArea value={alamat} onChange={this.onChange} placeholder='Alamat pegawai' name="alamat" />
                        <Form.Input value={nama_bank} onChange={this.onChange} name="nama_bank" placeholder='Nama Bank/Unit/Cabang/Capem' />                              
                        <Form.Input value={contact_bank} onChange={this.onChange} name="contact_bank" placeholder='Nomor contact bank' />               
                        <Form.TextArea value={alamat_bank} onChange={this.onChange} placeholder='Alamat bank tempat bertugas' name="alamat_bank" />               
                        <Form.Button positive>Submit</Form.Button>
                     </Form>
                  </Segment>
               </Grid.Column>
            </Grid>
         </div>
      );
   }
}

export default FormAddBank;



// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_userbank/FormAddBank.js